import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { SidebarComponent } from '../components/sidebar/sidebar.component';
import { TopbarComponent } from './topbar.component';
import { SidebarStateService } from './sidebar-state.service';
import { BackToTopComponent } from '../../shared/components/back-to-top/back-to-top.component';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [RouterOutlet, SidebarComponent, TopbarComponent, BackToTopComponent],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss',
})
export class MainLayoutComponent {
  private readonly sidebarState = inject(SidebarStateService);
  protected readonly isCollapsed = this.sidebarState.isCollapsed;

  protected closeSidebar(): void {
    this.sidebarState.setCollapsed(true);
  }
}
